export const sortOptions = [
  {
    label: "A-Z",
    key: "asc",
  },
  {
    label: "Z-A",
    key: "desc",
  },
]
export const LOCAL_PREFIX = ""

export const printElement = async function (elementId, uniqueIframeId) {
  const content = document.getElementById(elementId)
  let contentWindow
  if (document.getElementById(uniqueIframeId)) {
    contentWindow = document.getElementById(uniqueIframeId).contentWindow
  } else {
    const iframe = document.createElement("iframe")
    iframe.setAttribute("title", uniqueIframeId)
    iframe.setAttribute("id", uniqueIframeId)
    iframe.setAttribute("style", "height: 0px; width: 0px; position: absolute;")
    document.body.appendChild(iframe)
    contentWindow = iframe.contentWindow
  }
  contentWindow.document.open()
  contentWindow.document.write(content.innerHTML)
  const style = contentWindow.document.createElement("style")
  style.textContent =
    "body { overflow: visible!important; }.main { display: none; visibility: hidden; }#parent-print { display: block; visibility: visible; height: 100%; min-height: 100%; }html, body, #wrap {height: 100%; margin: 0; padding: 0;}body #parent-print #wrap {min-height: 100%; max-height: 100%; overflow: visible!important; }#main {height: 74.2%; width: 100%; text-align: center;}#main img {height: 97%; width: 100%; margin: 1% auto}#header {height: 20%; border-bottom:solid 1px #ccc; text-align:left;}#header.topPrint svg{height:95%; width:100%;}#footer { bottom: 0;  font-size: 8px; left: 0; padding:3px 0 0 0; width: 100%; height: 5%; position: absolute; border-top: solid 1px #ccc;}#footer .cod-prod{float:left; padding:0 0 0 10px;}#footer #inf-print{float:right; text-align:right; padding:0 10px 0 0; }#footer .date-print{ font-style: italic; color: #333; }#footer #pagination{position:absolute; z-index:1; left:50%; margin:0 0 0 -50px; width:100px; text-align:center; color: #8399B6;}#wrap {page-break-after: always; position: relative;}body.mozilla #main svg { height: 95%; width: 100%; max-height: 95%; }body.safari { height:9in; width: 8.5in; }body.safari #main img {max-height: 99%; max-width: 100%; margin: 5px auto}body.safari #parent-print #wrap #footer { font-size: 8px; left: 0; padding:3px 0 0 0; width: 100%; height: 2%; position: absolute; border-top: solid 1px #ccc;}body.safari #parent-print #wrap #main svg {height: 99%; width: 99%; margin: 5px auto; }"
  contentWindow.document.head.appendChild(style)
  contentWindow.document.close()
  await new Promise(r => setTimeout(r, 500))
  contentWindow.focus()
  contentWindow.print()
}

export const getUpdatedReplaceFile = currentFile => {
  if (!currentFile?.replacementParts && !currentFile?.replacementPartsInfo) {
    return currentFile
  }
  const parts = []
  currentFile?.Parts.forEach(value => {
    const rootSku = value?.Cod
    const currentVal = currentFile?.replacementParts[rootSku]
    const Key = currentVal ? currentVal?.ReplaceProductProductNo : null
    const replaceVal = currentFile?.replacementPartsInfo.filter(
      v => v.Cod === Key
    )[0]
    const partid = parts?.filter(v => v.Cod === rootSku)[0]
    if (!partid) {
      if (replaceVal) {
        const findVal = parts?.filter(v => v.Cod === replaceVal?.Cod)[0]
        if (!findVal) {
          replaceVal.replaceRootSku = rootSku
          parts.push(replaceVal)
        } else {
          findVal.replaceRootSku = rootSku
        }
      } else {
        parts.push(value)
      }
    }
  })
  return parts
}
